export const bucketSortCode = {
    c: `
  #include <stdio.h>
  #include <stdlib.h>
  
  void bucketSort(float arr[], int n) {
      if (n <= 0) return;
      float maxValue = arr[0];
      for (int i = 1; i < n; i++)
          if (arr[i] > maxValue)
              maxValue = arr[i];
  
      int bucketCount = (int)(maxValue) + 1;
      float** buckets = (float**)malloc(bucketCount * sizeof(float*));
      int* bucketSizes = (int*)malloc(bucketCount * sizeof(int));
  
      for (int i = 0; i < bucketCount; i++) {
          buckets[i] = (float*)malloc(n * sizeof(float));
          bucketSizes[i] = 0;
      }
  
      for (int i = 0; i < n; i++) {
          int index = (int)(arr[i]);
          buckets[index][bucketSizes[index]++] = arr[i];
      }
  
      for (int i = 0; i < bucketCount; i++)
          qsort(buckets[i], bucketSizes[i], sizeof(float), cmpfunc);
  
      int k = 0;
      for (int i = 0; i < bucketCount; i++)
          for (int j = 0; j < bucketSizes[i]; j++)
              arr[k++] = buckets[i][j];
  }`,
  
    cpp: `
  #include <vector>
  #include <algorithm>
  using namespace std;
  
  void bucketSort(vector<float>& arr) {
      if (arr.empty()) return;
      float maxValue = *max_element(arr.begin(), arr.end());
      int bucketCount = (int)(maxValue) + 1;
      vector<vector<float>> buckets(bucketCount);
  
      for (float num : arr) {
          int index = (int)(num);
          buckets[index].push_back(num);
      }
  
      for (auto& bucket : buckets)
          sort(bucket.begin(), bucket.end());
  
      arr.clear();
      for (const auto& bucket : buckets)
          arr.insert(arr.end(), bucket.begin(), bucket.end());
  }`,
  
    java: `
  import java.util.ArrayList;
  import java.util.Collections;
  
  public class BucketSort {
      public static void bucketSort(float[] arr) {
          if (arr.length <= 0) return;
          float maxValue = arr[0];
          for (float v : arr) {
              if (v > maxValue) {
                  maxValue = v;
              }
          }
  
          int bucketCount = (int)(maxValue) + 1;
          ArrayList<ArrayList<Float>> buckets = new ArrayList<>(bucketCount);
          for (int i = 0; i < bucketCount; i++) {
              buckets.add(new ArrayList<>());
          }
  
          for (float num : arr) {
              int index = (int)(num);
              buckets.get(index).add(num);
          }
  
          int k = 0;
          for (ArrayList<Float> bucket : buckets) {
              Collections.sort(bucket);
              for (float num : bucket) {
                  arr[k++] = num;
              }
          }
      }
  }`,
  
    python: `
  def bucketSort(arr):
      if len(arr) <= 0:
          return
      maxValue = max(arr)
      bucketCount = int(maxValue) + 1
      buckets = [[] for _ in range(bucketCount)]
  
      for num in arr:
          index = int(num)
          buckets[index].append(num)
  
      arr.clear()
      for bucket in buckets:
          bucket.sort()
          arr.extend(bucket)
  `
  };
  